import { render, staticRenderFns } from "./ExpenseGroup.vue?vue&type=template&id=a587a2da&scoped=true&"
import script from "./ExpenseGroup.vue?vue&type=script&lang=js&"
export * from "./ExpenseGroup.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseGroup.vue?vue&type=style&index=0&id=a587a2da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a587a2da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VChipGroup,VCol,VProgressCircular,VRow})
